var LazyServiceIdentifer = (function () {
    function LazyServiceIdentifer(cb) {
        this._cb = cb;
    }
    LazyServiceIdentifer.prototype.unwrap = function () {
        return this._cb();
    };
    return LazyServiceIdentifer;
}());
export { LazyServiceIdentifer };
//# sourceMappingURL=lazy_service_identifier.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/annotation/lazy_service_identifier.js
// module id = 849
// module chunks = 0